import axios from 'axios';
import { baseURL } from '../utils/baseUrls';

export interface TokenRegistrationResponse {
  success: boolean;
  message: string;
}

export class TokenRegistrationService {
  private readonly baseUrl: string;

  constructor(baseUrl: string = baseURL) {
    this.baseUrl = baseUrl;
  }

  /**
   * Register a token with the developer dashboard API
   * @param token - The JWT token to register
   * @returns Promise<TokenRegistrationResponse>
   */
  async registerToken(token: string): Promise<TokenRegistrationResponse> {
    try {
      const response = await axios.post<TokenRegistrationResponse>(
        `${this.baseUrl}/api/v1/auth/register-token`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );

      return response.data;
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          `Failed to register token: ${
            error.response?.data?.message || error.message
          }`,
        );
      }
      throw new Error('Failed to register token: Unknown error');
    }
  }

  async invalidateToken({ token }: { token: string }): Promise<void> {
    try {
      await axios.post(
        `${this.baseUrl}/api/v1/auth/logout`,
        {},
        {
          headers: {
            Authorization: `Bearer ${token}`,
          },
        },
      );
    } catch (error) {
      if (axios.isAxiosError(error)) {
        throw new Error(
          `Failed to invalidate token: ${
            error.response?.data?.message || error.message
          }`,
        );
      }
      throw new Error('Failed to invalidate token: Unknown error');
    }
  }
}
